(() => {
  if (customElements.get('rr-region-menu')) return;
  class RegionMenu extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const signal = this.events.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('.rr-region-menu__toggle');
        if (!button) return;
        const opening = button.getAttribute('aria-expanded') !== 'true';
        this.close();
        if (opening) {
          button.setAttribute('aria-expanded', 'true');
          this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))).hidden = false;
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('.rr-region-menu__toggle[aria-expanded="true"]');
        if (!open) return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
        open.focus();
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
      this.closest('details')?.addEventListener('toggle', event => {
        if (!event.target.open) this.close();
      }, { signal });
    }
    close() {
      this.querySelectorAll('.rr-region-menu__toggle').forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('.rr-region-menu__sublist').forEach(list => { list.hidden = true; });
    }
    disconnectedCallback() { this.events?.abort(); }
  }
  customElements.define('rr-region-menu', RegionMenu);
})();
